import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LanguageCode } from '../data/laguage-code';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class ChangeLangEventService {
    private langCode = LanguageCode.DE;
    private selectedLanguage$: BehaviorSubject<LanguageCode>;

    constructor(private translateService: TranslateService) {
        this.langCode = this.retrieveBrowserLanguage();

        this.selectedLanguage$ = new BehaviorSubject<LanguageCode>(
            this.langCode
        );
    }

    public getChangeLang(): Observable<LanguageCode> {
        return this.selectedLanguage$.asObservable();
    }

    setLangSubject(data: LanguageCode): void {
        this.selectedLanguage$.next(data);
    }

    retrieveBrowserLanguage(): LanguageCode {
        const currentBrowserLang = this.translateService.getBrowserLang();

        if (currentBrowserLang === 'de') return LanguageCode.DE;

        return LanguageCode.EN;
    }
}
